import { render, staticRenderFns } from "./PathJourney.vue?vue&type=template&id=61f0d11d&scoped=true&"
import script from "./PathJourney.vue?vue&type=script&lang=js&"
export * from "./PathJourney.vue?vue&type=script&lang=js&"
import style0 from "./PathJourney.vue?vue&type=style&index=0&id=61f0d11d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61f0d11d",
  null
  
)

export default component.exports